/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ComponentGroups } from '../../models/component-groups';

export interface TenantsTenantIdCatalogEntriesComponentGroupsGet$Params {
  tenantId: string;
  includeDeleted?: boolean;
  size?: string;
  start?: string;
}

export function tenantsTenantIdCatalogEntriesComponentGroupsGet(http: HttpClient, rootUrl: string, params: TenantsTenantIdCatalogEntriesComponentGroupsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<ComponentGroups>> {
  const rb = new RequestBuilder(rootUrl, tenantsTenantIdCatalogEntriesComponentGroupsGet.PATH, 'get');
  if (params) {
    rb.path('tenantId', params.tenantId, {});
    rb.query('includeDeleted', params.includeDeleted, {});
    rb.query('size', params.size, {});
    rb.query('start', params.start, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ComponentGroups>;
    })
  );
}

tenantsTenantIdCatalogEntriesComponentGroupsGet.PATH = '/tenants/{tenantId}/catalog-entries/component-groups';
